/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/prefer-hubspot-url-utils */

'use es6';

import { eu1 } from 'hubspot-url-utils/hublets';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import LinkContent from '../components/LinkContent';
import Link from 'academy-shared-js/records/Link';
import ImmutablePropTypes from 'react-immutable-proptypes';
import UsageTracker from '../utils/UsageTracker';
import { getContentById } from '../selectors/contentSelectors';
import { TrackingContentTypes } from '../constants/Tracking';
import { updateContentProgress } from '../features/userProgress';
import { jsx as _jsx } from "react/jsx-runtime";
class LinkContentContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasClicked: false
    };
    this.handleRead = this.handleRead.bind(this);
    this.handleSkip = this.handleSkip.bind(this);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.contentId !== this.props.contentId) {
      this.setState({
        hasClicked: false
      });
    }
  }
  handleRead() {
    this.setState({
      hasClicked: true
    });
    const {
      content,
      trackName,
      trackId,
      lessonName,
      lessonId
    } = this.props;
    UsageTracker.track('contentInteraction', {
      action: 'read-link',
      contentId: content.get('id'),
      contentLanguage: content.get('language'),
      contentType: TrackingContentTypes.LINK,
      trackId,
      lessonId,
      lessonName,
      trackName,
      linkType: content.get('linkType')
    });
    updateContentProgress({
      contentId: Number(this.props.contentId),
      trackId: Number(trackId),
      lessonId: Number(lessonId),
      language: content.get('language')
    });
  }
  handleSkip() {
    const {
      content,
      trackName,
      trackId,
      lessonId,
      onFinish
    } = this.props;
    UsageTracker.track('contentInteraction', {
      action: 'skip-link',
      contentId: content.get('id'),
      contentLanguage: content.get('language'),
      contentType: TrackingContentTypes.LINK,
      trackId,
      lessonId,
      trackName,
      linkType: content.get('linkType')
    });
    updateContentProgress({
      contentId: Number(this.props.contentId),
      trackId: Number(trackId),
      lessonId: Number(lessonId),
      language: content.get('language')
    });
    onFinish();
  }
  render() {
    const {
      content,
      onFinish
    } = this.props;
    let targetUrl = content.get('targetUrl');
    if ( /* eslint-disable-next-line hubspot-dev/no-hublet-comparison, hubspot-dev/no-hublet-references */
    window.location.hostname.includes(eu1) && content.get('linkType') !== 'HUBSPOT_COMMUNITY') targetUrl = content.get('targetUrl').replaceAll('app.hubspot.com', 'app-eu1.hubspot.com');
    return /*#__PURE__*/_jsx(LinkContent, {
      contentType: content.get('linkType'),
      ctaCopy: content.get('ctaCopy'),
      description: content.get('description'),
      hasClicked: this.state.hasClicked,
      href: targetUrl,
      name: content.get('name'),
      onFinish: onFinish,
      onRead: this.handleRead,
      onSkip: this.handleSkip
    });
  }
}
LinkContentContainer.propTypes = {
  content: ImmutablePropTypes.recordOf(Link).isRequired,
  contentId: PropTypes.string.isRequired,
  lessonId: PropTypes.string.isRequired,
  lessonName: PropTypes.string.isRequired,
  onFinish: PropTypes.func,
  trackId: PropTypes.string,
  trackName: PropTypes.string
};
function mapStateToProps(state, ownProps) {
  const thisContent = getContentById(state, ownProps.contentId);
  return {
    content: thisContent
  };
}
export default connect(mapStateToProps)(LinkContentContainer);